export default __webpack_public_path__ + "bfx/static/media/search_modal.0327d369.svg";